import { render, staticRenderFns } from "./couponManagement.vue?vue&type=template&id=61f5088a&"
import script from "./couponManagement.vue?vue&type=script&lang=js&"
export * from "./couponManagement.vue?vue&type=script&lang=js&"
import style0 from "./couponManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports